import { DialogContent, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAPI, useSDK } from 'stores';

const Ownereshipcard = (props: any) => {
	const { t, i18n } = useTranslation();
	const { genOwnershipCard } = useAPI();
	const [image, setImage] = React.useState('');
	const { sysInfo } = useSDK();
	let reqCode = props.requestedUAID;
	//console.log(sysInfo!.equipmentOS);
	//console.log(sysInfo!.equipmentPlatform);

	useEffect(() => {
		let ownershipCardInfo = localStorage.getItem(reqCode);
		let ownershipCardInfoInJSON = ownershipCardInfo
			? JSON.parse(ownershipCardInfo)
			: null;

		if (!ownershipCardInfoInJSON) {
			console.log("ownership card info doesn't exist");
			console.log(ownershipCardInfo);
			return;
		}

		let signature = ownershipCardInfoInJSON?.signature;
		let scantime = ownershipCardInfoInJSON?.scantime;

		let response = genOwnershipCard(signature, scantime, reqCode);
		response
			.then((value) => {
				let image = value.data;
				setImage(
					`${process.env.REACT_APP_DOMAIN_NAME}/api/file/getImg?name=` +
						image
				);
			})
			.catch();
	}, []);

	function saveImage() {
		const a = document.createElement('a');
		a.download = reqCode + '.png'; //this may not work...
		a.href = image;
		a.click();
	}

	return (
		<>
			{/*
			<DialogTitle style={{ display: image === '' ? 'None' : 'block' }}>
				<Box>
					<HighlightOffIcon/>
				</Box>
			</DialogTitle>
	        */}
			<DialogContent style={{ display: image === '' ? 'None' : 'block' }}>
				{/*<div style={{ display: image === '' ? 'flex' : 'None' }}>
					<Box sx={{ textAlign: 'center' }}>
						<CircularProgress />
					</Box>
                </div>*/}
				<div>
					<div>
						<img
							style={{
								maxWidth: '100%',
								maxHeight: 'calc(100vh - 64px)',
							}}
							src={image}
							alt={t('nav.logo')}
						/>
					</div>
					<div style={{ textAlign: 'center' }}>
						{sysInfo!.equipmentOS !== 'iOS' && (
							<Button
								style={{
									width: '30%',
									height: '50%',
									justifyContent: 'center',
									background: '#990637',
									color: 'white',
								}}
								onClick={saveImage}
							>
								{t('ownershipCard.save')}
							</Button>
						)}

						{sysInfo!.equipmentOS === 'iOS' &&
							sysInfo!.equipmentPlatform === 'mobile' && (
								<Typography
									variant="body1"
									sx={{ color: 'primary.main' }}
								>
									{t('ownershipCard.saveiOS.action')}
								</Typography>
							)}
					</div>
				</div>
			</DialogContent>
		</>
	);
};

export default Ownereshipcard;
